// extracted by mini-css-extract-plugin
export default {"root":"AppLinkButton_root__qQZ8l"};